import React, { useState } from 'react';
import { usePathname } from 'next/navigation';
import { i18n } from '@/i18n-config';
import { useMenu } from '@/context/MenuContext';
import { useMainNavigationItems } from '@/constants/navigation-items';
import { getActiveLocale } from '@/utils/active-locale';
import { LocaleSwitcher } from '@/components/layout/locale-switcher';
import { DesktopSubNavigation } from './DesktopSubNavigation';
import { LogoLink } from './LogoLink';
import { SubNavigator } from './SubNavigator';
import { MainNavigator } from './MainNavigator';

export async function generateStaticParams() {
  return i18n.locales.map((locale) => ({ lang: locale }));
}

export interface NavItem {
  name: string;
  href: string;
  subItems?: NavItem[];
}

const DesktopNavigation = () => {
  const pathname = usePathname();
  const { setMobileMenuOpen } = useMenu();
  const navigation = useMainNavigationItems();
  const activeLocale = getActiveLocale();

  const [activeSubNav, setActiveSubNav] = useState<NavItem | null>(null);
  const monoNavigation = navigation.filter((nav) => nav.href !== `/${activeLocale}` && nav.href !== `/${activeLocale}/voor-talenten` && nav.href !== `/${activeLocale}/voor-opdrachtgevers`);
  const polyNavigation = navigation.filter((nav) => nav.href === `/${activeLocale}/voor-talenten` || nav.href === `/${activeLocale}/voor-opdrachtgevers`);

  return (
    // Extra padding-bottom zorgt ervoor dat de hover-zone (voor main nav en subnav) groot genoeg is.
    <div className='relative pb-0' onMouseLeave={() => setActiveSubNav(null)}>
      {/* MAIN NAVIGATION BAR */}
      <nav className='flex relative items-center justify-between h-16 px-6 lg:px-10 font-fractul  z-50' aria-label='Global'>
        <LogoLink />
        
        <div className='flex lg:hidden'>
          <span className='sr-only'>Open main menu</span>
          <button className='text-white font-fractul' onClick={() => setMobileMenuOpen(true)}>
            Menu
          </button>
        </div>

        <div className='hidden lg:flex lg:items-center lg:gap-x-12 h-full cursor-pointer'>
          {polyNavigation.map((item) => (
            <SubNavigator key={item.name} item={item} pathname={pathname} activeSubNav={activeSubNav} setActiveSubNav={setActiveSubNav} />
          ))}

          {monoNavigation.map((item) => (
            <MainNavigator key={item.name} item={item} pathname={pathname} />
          ))}
        </div>

        <div className='hidden lg:flex lg:flex-1 lg:items-center lg:justify-end'>
          <LocaleSwitcher textColor='text-white' />
        </div>
      </nav>

      {/* SUBNAVIGATION BAR (SECOND BLOCK BELOW MAIN NAV) */}
      <DesktopSubNavigation activeSubNav={activeSubNav} setActiveSubNav={setActiveSubNav} pathname={pathname} />
    </div>
  );
};

export default DesktopNavigation;
